import React from "react";
import { Col, Row } from "react-bootstrap";
import { FaCheck } from "react-icons/fa";
import { HiXMark } from 'react-icons/hi2'
import { MdOutlineSolarPower } from "react-icons/md";
import { SlEnergy } from "react-icons/sl";
import { TbFlame } from "react-icons/tb";


/**
 * 
 * @param {param} data object with data
 * @returns text
 */
const SummaryStage = ({ data }) => {
    return (
        <>
            <Row className="mt-5">
                <Col xl="6">
                    <p className="text-energo">Anlagenadresse</p>
                    <p>Straße und Hausnummer &nbsp; <span className="text-muted">{data.street} {data.houseNumber}</span></p>
                        {data.anlageUse === 'Wohnung' || data.anlageUse === 'Gewerbe'? 
                        <>
                                <p>Stiege/Stockwerk &nbsp; 
                                    {data.staircase === ""?
                                        <HiXMark className="text-danger" />
                                        :
                                        <span className="text-muted">{data.staircase}</span>
                                    }
                                </p>
                                <p>Top &nbsp; <span className="text-muted">{data.top}</span></p>
                                <p>Bestandseinheitennummer &nbsp; 
                                    {data.bestand === ""?
                                        <HiXMark className="text-danger" />
                                        :
                                        <span className="text-muted">{data.bestand}</span>
                                    }
                                </p>
                            </>
                        :
                        null
                    }
                    <p className="text-energo">Anlagenverwendung</p>
                    <p>Anlagenverwendung &nbsp; <span className="text-muted">{data.anlageUse}</span></p>
                    {
                        data.anlageUse === 'Allgemeine Liegenschaftsteile' ? <p>Spezifische Anlagenverwendung &nbsp; <span className="text-muted">{data.anlageUseDesc}</span></p> 
                        :null 
                    }
                </Col>
                <Col xl="6">
                    <p className="text-energo">Anlagedaten</p>
                    <p>Energieform &nbsp; <span className="text-muted">
                        {
                            data.energyForm === "Strom" ? <SlEnergy className="text-energo mb-1" /> :
                            data.energyForm === "Gas" ? <TbFlame className="text-info mb-1" /> :
                            data.energyForm === "Strom-Einspeisung"? <MdOutlineSolarPower className="text-warning mb-1" />:
                            null
                        } {data.energyForm}
                    </span></p>
                    <p hidden={data.energyForm === "Gas"}>Smartmeter &nbsp; <span className="text-muted">
                        {data.smartmeter? 
                            <><FaCheck className="text-energo mb-1"/> Ja</>: 
                            <><HiXMark className="text-danger mb-1"/> Nein</>
                        }
                        </span>
                    </p>
                    <p hidden={data.energyForm === "Gas"}>Zweiter Zähler vorhanden &nbsp; <span className="text-muted">
                        {data.secondZaehler? 
                            <><FaCheck className="text-energo mb-1"/> Ja</>: 
                            <><HiXMark className="text-danger mb-1"/> Nein</>
                        }
                        </span>
                    </p>
                    <p>Zählernummer &nbsp; <span className="text-muted">{data.zaehlerNumber1}</span></p>
                    <p hidden={data.secondZaehler === false}>Zweite Zählernummer &nbsp; <span className="text-muted">{data.zaehlerNumber2}</span></p>
                </Col>
            </Row>
            <Row className="mt-5" hidden={data.register === false}>
                <Col xl="6">
                    <p className="text-energo">Anmeldedaten</p>
                    <p>Anmelden am &nbsp; <span className="text-muted">{new Date(data.registerDate).toLocaleDateString('DE-de')}</span></p>
                    <p hidden={data.anlageUse === "Allgemeine Liegenschaftsteile"}>Als Leerstand anmelden &nbsp; <span className="text-muted">
                        {data.asLeerstand? 
                            <><FaCheck className="text-energo mb-1"/> Ja</>: 
                            <><HiXMark className="text-danger mb-1"/> Nein</>
                        }
                        </span>
                    </p>
                    <p hidden={data.zaehlerstand1 === ""}>Zählerstand &nbsp; <span className="text-muted">{data.zaehlerstand1}</span></p>
                    <p hidden={data.zaehlerstand2 === ""}>Zweiter Zählerstand &nbsp; <span className="text-muted">{data.zaehlerstand2}</span></p>
                    <p>Abrechnung über Messtechnikunternehmen &nbsp; <span className="text-muted">
                        {data.useMtu? 
                            <><FaCheck className="text-energo mb-1"/> Ja</>: 
                            <><HiXMark className="text-danger mb-1"/> Nein</>
                        }
                        </span>
                    </p>
                </Col>
                <Col xl="6" hidden={data.useMtu === false}>
                    <p className="text-energo">Messtechnikunternehmen</p>
                    <p>Messtechnikunternehmen &nbsp; <span className="text-muted">{data.mtuName}</span></p>
                    <p>Direktverrechnung &nbsp; <span className="text-muted">
                        {data.mtuDirect? 
                            <><FaCheck className="text-energo mb-1"/> Ja</>: 
                            <><HiXMark className="text-danger mb-1"/> Nein</>
                        }
                        </span>
                    </p>

                    <p hidden={data.mtuDirect === false}>MTU zahlt per Überweisung &nbsp; <span className="text-muted">
                        {data.mtuPaysOverTransfer? 
                            <><FaCheck className="text-energo mb-1"/> Ja</>: 
                            <><HiXMark className="text-danger mb-1"/> Nein</>
                        }
                        </span>
                    </p>
                    <p hidden={data.cardHolder === ""}>Kontoinhaber &nbsp; <span className="text-muted">{data.cardHolder}</span></p>
                    <p hidden={data.iban === ""}>IBAN &nbsp; <span className="text-muted">{data.iban}</span></p>
                </Col>
            </Row>
        </>
    );
};
export default SummaryStage;
